import { render, staticRenderFns } from "./DetailsBillsPayment.vue?vue&type=template&id=96d5c41c"
import script from "./DetailsBillsPayment.vue?vue&type=script&lang=js"
export * from "./DetailsBillsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports